export var BannerType;
(function (BannerType) {
    BannerType["NONE"] = "NONE";
    BannerType["TRAINER"] = "TRAINER";
    BannerType["TRAINEE"] = "TRAINEE";
})(BannerType || (BannerType = {}));
